import { useEffect } from 'react';

import { usePlexRoute } from './usePlexRoute';

export function useCloseOnDelete({ loading, deleted }: { loading: boolean; deleted: boolean }): void {
  const [, updatePlexRoute] = usePlexRoute();

  useEffect(() => {
    if (!loading && deleted) {
      updatePlexRoute({ selectedItem: undefined });

      // TODO(https://github.com/all-hands-hq/source/issues/342): Further improvements
    }
  });
}
